import { SubpageLayout2018 } from './subpageLayout';

const members = [
  {
    name: 'MS. ANNA LIN, JP, FCILT',
    title: 'Chief Executive of GS1 Hong Kong',
    image: '/2018/images/advisory_member-1.jpg',
    id: 'member_1',
  },
  {
    name: 'DR. KEN FONG',
    title: 'Honorary Chairman (Life), Hong Kong Wireless Technology Industry Association',
    image: '/2018/images/advisory_member-2.jpg',
    id: 'member_2',
  },
  {
    name: 'DR. TOA CHARM',
    title: 'Chief Public Mission Officer, Cyberport',
    image: '/2018/images/advisory_member-3.jpg',
    id: 'member_3',
  },
  {
    name: 'IR. PETER YEUNG',
    title: 'Head of Electronics & ICT Clusters, Smart City Platform, Hong Kong Science & Technology Parks Corporation',
    image: '/2018/images/advisory_member-4.jpg',
    id: 'member_4',
  },
  {
    name: 'MR. MOHAMED DIN BUTT',
    title: 'Executive Director, Hong Kong Productivity Council',
    image: '/2018/images/advisory_member-5.jpg',
    id: 'member_5',
  },
  {
    name: 'PROFESSOR JOSHUA MOK KA-HO',
    title: 'Vice President, Lingnan University',
    image: '/2018/images/advisory_member-6.jpg',
    id: 'member_6',
  },
];

export default function Advisory2018() {
  return (
    <SubpageLayout2018 lang="en" title="Advisory Board" page="advisory">
      <div className="para_introduction advisory-page">
        <h1>Advisory Board</h1>
        <div className="center_introduction">
          <p className="p1"></p>
        </div>
        <div className="head_advisory_container">
          <div className="head_advisory_photo_container_responsive">
            <div className="head_advisory_photo">
              <img src="/2018/images/advisory_head.jpg" alt="" />
            </div>
          </div>
          <div className="head_advisory_text_container animate" data-animate="slideInRight" data-duration="1.0s" data-delay="0.1s" data-offset="100">
            <div className="head_advisory_subject">Head of Advisory</div>
            <div className="head_advisory_name">DR. WINNIE TANG, JP</div>
            <div className="head_advisory_title">
              Founder and Honorary President,
              <br />
              Smart City Consortium (SCC)
            </div>
            <div className="head_advisory_text">
              Dr. Winnie Tang, JP, is an Honorary Professor in the Department of Computer Science at the University of Hong Kong. She is one of the locally-bred IT entrepreneurs of Hong Kong. In the 1990s, Dr. Tang founded Esri China (Hong Kong) Limited to develop and promote Geographic Information System (GIS) software and solutions. Over the years, Dr. Tang has been actively advocating the use of technology through her services in government and non-government organizations in Hong Kong. In recognition of Dr. Tang's outstanding contributions to society, she was recognised as one the Distinguished Alumni by the Faculty of Science of HKU in 2009 and as one of the Ten Outstanding Young Persons of the year by the Junior Chamber International Hong Kong (JCIHK) in 2006. Dr. Tang also received the Young Achiever of the Year in the Women of Influence Award presented by the American Chamber of Commerce in 2004.
            </div>
          </div>
          <div className="head_advisory_photo_container animate" data-animate="fadeIn" data-duration="1.0s" data-delay="0.1s" data-offset="100">
            <div className="head_advisory_photo">
              <img src="/2018/images/advisory_head.jpg" alt="" />
            </div>
          </div>
        </div>
        <div className="board_members_container_bg">
          <div className="board_members_container animate" data-animate="fadeIn" data-duration="1.0s" data-delay="0.1s" data-offset="100">
            <div className="board_members_subject" style={{ fontSize: 36, fontWeight: 'bold', marginBottom: 10 }}>Board Members</div>
            <div className="member_all">
              {members.map((m) => (
                <div className={`member ${m.id.replace('_', '_')}`} id={m.id} key={m.id}>
                  <div className="member_photo">
                    <img src={m.image} alt="" />
                  </div>
                  <div className="member_text_container">
                    <div className="member_text_name" style={{ fontSize: 20, fontWeight: 'bold' }}>{m.name}</div>
                    <div className="member_text_title" style={{ fontSize: 16, fontWeight: 100 }}>{m.title}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </SubpageLayout2018>
  );
}

